import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { PAYMENT_METHOD_PATH } from '../../../../config/paths';
import PaymentMethodDeleteButton from './PaymentMethodDeleteButton';

const PaymentMethodToolbar = ({ paymentMethodId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${PAYMENT_METHOD_PATH}/${paymentMethodId}/edit`} />{' '}
      <PaymentMethodDeleteButton paymentMethodId={paymentMethodId} />
    </div>
  </ButtonToolbar>
);

PaymentMethodToolbar.propTypes = {
  paymentMethodId: PropTypes.number.isRequired,
};

export default PaymentMethodToolbar;
